
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1RPPn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $6FQwA = parcelRequire("6FQwA");


var $6G33C = parcelRequire("6G33C");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $i25hX = parcelRequire("i25hX");


var $i1Nyn = parcelRequire("i1Nyn");

const $9c01cb8634406aa0$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext, setDashboardContext: setDashboardContext, setAIFeatureContext: setAIFeatureContext, setJiraCreateContext: setJiraCreateContext, mergeDatabaseContext: mergeDatabaseContext, setPageSmartLinks: setPageSmartLinks } = (0, $i1Nyn.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i25hX.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    case 'dashboard-insights-actions':
                        setDashboardContext(payload.data);
                        break;
                    case 'database-context-payload':
                        mergeDatabaseContext(payload.data);
                        break;
                    case 'set-message-context':
                        setAIFeatureContext(payload.data);
                        break;
                    case 'jira-create-context-payload':
                        setJiraCreateContext(payload.data);
                        break;
                    case 'smartlinks-context-payload':
                        setPageSmartLinks(payload.data);
                        break;
                    default:
                }
            } catch  {}
        }
    });
};









var $dh538 = parcelRequire("dh538");








var $h982G = parcelRequire("h982G");


var $kIvLT = parcelRequire("kIvLT");

// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $1e89963f4bf21cf4$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);
const $1e89963f4bf21cf4$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $1e89963f4bf21cf4$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const [triggerOpen, setTriggerOpen] = (0, $42omo.useState)(!!(0, $6FQwA.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $42omo.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $i25hX.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $1e89963f4bf21cf4$var$ignoredEvents.has(type);
        if (!$1e89963f4bf21cf4$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        // Extract conversation ID from chat-open events
        const conversationId = type === 'chat-open' && 'data' in payload ? payload.data.channelId : undefined;
        const openChatMode = 'openChatMode' in payload ? payload.openChatMode : undefined;
        if ((0, $dh538.fg)('fix-jira-ai-plugin-dropdown-overlap')) onTriggerOpeningChat(conversationId, openChatMode, source);
        else onTriggerOpeningChat(conversationId, openChatMode);
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h982G.RovoPostMessagePubsubListener), {})
    });
};


var $5qqdA = parcelRequire("5qqdA");

var $hR4U4 = parcelRequire("hR4U4");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $bQm3c = parcelRequire("bQm3c");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $1AJi3 = parcelRequire("1AJi3");

const $3730deece820a964$export$69cf3fc83b854da4 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant, isConversationAssistantSidebarActive: isConversationAssistantSidebarActive } = (0, $1AJi3.useToggleConversationAssistant)();
    const handleOnClick = (0, $42omo.useCallback)((e)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'aiMate',
                source: 'AIMate',
                attributes: {
                    opened: !isConversationAssistantSidebarActive,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4'
                },
                tags: [
                    'atlaskit',
                    'aiMate'
                ]
            }
        }).fire();
        e.preventDefault();
        toggleConversationAssistant();
    }, [
        createAnalyticsEvent,
        isConversationAssistantSidebarActive,
        toggleConversationAssistant
    ]);
    const universalAIMateShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_AI_MATE_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_AI_MATE_SHORTCUT_WIN);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: universalAIMateShortcut
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        paddingInlineStart: "space.050",
        testId: "app-navigation-ai-mate"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6G33C.ConversationAssistantButtonNav4), {
        siteId: cloudId,
        productKey: "confluence",
        onClick: handleOnClick,
        isActive: isConversationAssistantSidebarActive,
        tooltipContent: (0, $5qqdA.CONVERSATION_ASSISTANT_BRAND_NAME),
        shortcut: // No shortcut on edit pages
        !isLiveEditMode && !isOnEditRoute ? shortcutStrings : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c01cb8634406aa0$export$29ff0802eb3bb217), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e89963f4bf21cf4$export$6fa95a645837361b), {
        onTriggerOpeningChat: (conversationId, openChatMode)=>{
            if (isConversationAssistantSidebarActive || mode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL) return;
            conversationId && (0, $6FQwA.updatePageRovoParams)({
                pathway: 'chat',
                conversationId: conversationId
            });
            toggleConversationAssistant(openChatMode);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.AI_MATE_SHORTCUT) : undefined,
        accelerator: universalAIMateShortcut,
        listener: ()=>toggleConversationAssistant('sidebar'),
        isAppNavigationShortcut: true
    }));
};
module.exports["ConversationAssistantNavBarButton"] = $3730deece820a964$export$69cf3fc83b854da4;

});

parcelRegister("6FQwA", function(module, exports) {

var $kGZ7I = parcelRequire("kGZ7I");

const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("kGZ7I", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen'
];
module.exports["ROVO_PARAM_PREFIX"] = $0075612de7c1f282$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $0075612de7c1f282$export$3cd6b610e7ede579;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("h982G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $i25hX = parcelRequire("i25hX");

const $a5e138d08f3fc65b$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $a5e138d08f3fc65b$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $a5e138d08f3fc65b$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $a5e138d08f3fc65b$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $a5e138d08f3fc65b$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($a5e138d08f3fc65b$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $a5e138d08f3fc65b$var$allowedOrigins.includes(hostname));
};
const $a5e138d08f3fc65b$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $a5e138d08f3fc65b$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $a5e138d08f3fc65b$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, (0, $dh538.fg)('ai-mate-pub-sub-post-message-origin-fix') ? {
                        targetOrigin: '*'
                    } : undefined);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $a5e138d08f3fc65b$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $42omo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $a5e138d08f3fc65b$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $42omo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $a5e138d08f3fc65b$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["RovoPostMessagePubsubListener"] = $a5e138d08f3fc65b$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $a5e138d08f3fc65b$export$5340cc94dd0ecbea;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("1AJi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("8unJx", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt }, { reset: reset, clearInitialPrompt: clearInitialPrompt, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("gKlAz", function(module, exports) {

var $eG1Z0 = parcelRequire("eG1Z0");


var $aoDcQ = parcelRequire("aoDcQ");

function $ac303ab343815a94$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $aoDcQ.text)(maybeNode) : maybeNode;
    if ((0, $eG1Z0.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $eG1Z0.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $ac303ab343815a94$export$50d34f59d07755a2;

});

parcelRegister("eG1Z0", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9abe739d14fcbdba$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $9abe739d14fcbdba$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}
module.exports["isDuplicateMark"] = $9abe739d14fcbdba$export$5ec47a80d7cc0dfa;
module.exports["duplicateMarkError"] = $9abe739d14fcbdba$export$db1000b9ac08ce57;

});

parcelRegister("iJQnc", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $0c4bf63002e7b177$export$6565f9f03506010b = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $0c4bf63002e7b177$export$6565f9f03506010b;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $42omo.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("aGop9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");


var $efXed = parcelRequire("efXed");


var $17zLw = parcelRequire("17zLw");

const $90c58b5063b4a6d0$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $17zLw.ThemedButton) : (0, $ccHMk.default);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        ...props
    });
});
module.exports["Button"] = $90c58b5063b4a6d0$export$353f5b6fc5456de1;

});

parcelRegister("17zLw", function(module, exports) {
/* themed-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $lcVz9 = parcelRequire("lcVz9");


var $i63G2 = parcelRequire("i63G2");

const $246516ea69fcef3e$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $246516ea69fcef3e$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $i63G2.ThemedPressable), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $246516ea69fcef3e$var$textButtonStyles.iconBefore
                ]),
                children: (0, $dh538.fg)('platform_themed_button_use_icon_renderer') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lcVz9.default), {
                    icon: IconBefore
                }) : /*#__PURE__*/ (0, $l998X.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $246516ea69fcef3e$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
module.exports["ThemedButton"] = $246516ea69fcef3e$export$f67fb575035cc7d0;

});

parcelRegister("hwWwS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9b64448510e1eff4$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $42omo.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};
module.exports["useCoordination"] = $9b64448510e1eff4$export$3c29cca421979b0e;

});

parcelRegister("1NxpI", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $4qrTW = parcelRequire("4qrTW");


var $drbbL = parcelRequire("drbbL");

function $d260874c410d6e1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $d260874c410d6e1a$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $d260874c410d6e1a$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $d260874c410d6e1a$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $d260874c410d6e1a$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            [$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $d260874c410d6e1a$var$buttonBaseStyles,
            isHighlighted && $d260874c410d6e1a$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $drbbL.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $d260874c410d6e1a$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});
module.exports["PrimaryButton"] = $d260874c410d6e1a$export$ac16a6a04d9b7c84;

});

parcelRegister("drbbL", function(module, exports) {
const $8b859f9800f72dd2$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getPrimaryButtonTheme"] = $8b859f9800f72dd2$export$14dd6915caf431fe;

});


//# sourceMappingURL=navBarButton.51a0d09c.js.map
